(function () {
  'use strict';

  var STORAGE_KEY = 'evdnce_gender';
  var IS_HOME = window.location.pathname === '/' || window.location.pathname === '';
  var IS_DESIGN_MODE = document.documentElement.classList.contains('shopify-design-mode');

  var MEN_SUB_FALLBACK = [
    { label: 'New Arrivals', url: '/collections/mens-new-arrivals', children: [] },
    { label: '02 Tees',      url: '/collections/evd02-mens', children: [] },
    { label: 'Stride',       url: '/collections/mens-stride-collection', children: [] },
    { label: 'Core',         url: '/collections/mens-core', children: [] },
    { label: "Cunnie's Club", url: '/collections/cunnies-club', children: [] },
    { label: 'Shop All',     url: '/collections/men', children: [] }
  ];
  var WOMEN_SUB_FALLBACK = [
    { label: 'New Arrivals',      url: '/collections/womens-new-arrivals', children: [] },
    { label: 'Cloud Compression', url: '/collections/womens-cloud-compression', children: [] },
    { label: 'Stride',            url: '/collections/women-stride-collection', children: [] },
    { label: 'Core',              url: '/collections/womens-core-collection', children: [] },
    { label: 'Loungewear',        url: '/collections/womens-loungewear', children: [] },
    { label: 'Shop All',          url: '/collections/women', children: [] }
  ];
  var EVDNCE_SUB_FALLBACK = [
    { label: 'New Arrivals', url: '/collections/new-arrivals', children: [] },
    { label: 'Stride',       url: '/collections/stride-collection', children: [] },
    { label: 'Core',         url: '/collections/core-collection', children: [] },
    { label: 'Shop All',     url: '/collections/all', children: [] }
  ];

  var SUBNAV_DATA = null;
  function getSubnavData() {
    if (SUBNAV_DATA) return SUBNAV_DATA;
    var el = document.getElementById('evdnce-subnav-data');
    if (el) { try { SUBNAV_DATA = JSON.parse(el.textContent); } catch(e) {} }
    return SUBNAV_DATA || {};
  }

  function getSubNavItems(gender) {
    var data = getSubnavData();
    if (data[gender] && data[gender].length) return data[gender];
    if (gender === 'men')   return MEN_SUB_FALLBACK;
    if (gender === 'women') return WOMEN_SUB_FALLBACK;
    return EVDNCE_SUB_FALLBACK;
  }

  function isMobile() { return window.innerWidth < 990; }

  function getGender() {
    try {
      var ls = localStorage.getItem(STORAGE_KEY);
      if (ls) return ls;
      var ss = sessionStorage.getItem(STORAGE_KEY);
      if (ss) { localStorage.setItem(STORAGE_KEY, ss); return ss; }
    } catch (e) {}
    return null;
  }

  function setGender(g) {
    try { localStorage.setItem(STORAGE_KEY, g); } catch (e) {}
    try { sessionStorage.setItem(STORAGE_KEY, g); } catch (e) {}
    document.body.setAttribute('data-evdnce-gender', g);
    document.documentElement.setAttribute('data-evdnce-g', g);
  }

  function genderFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var gUrl = params.get('gender');
    if (gUrl === 'men' || gUrl === 'women' || gUrl === 'evdnce') return gUrl;
    var filter = params.get('filter.v.t.shopify.target-gender');
    if (filter) return filter.includes('TaxonomyValue/19') ? 'men' : 'women';
    var path = window.location.pathname.toLowerCase();
    if (path.match(/\/collections\/[^/]*women/)) return 'women';
    if (path.match(/\/collections\/[^/]*men/))   return 'men';
    return null;
  }

  var CHEVRON_SVG = '<svg class="evdnce-sub-nav__chevron" viewBox="0 0 10 6" width="8" height="8"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/></svg>';

  function buildSubNav(items, currentPath) {
    return items.map(function (item) {
      var isActive = item.url !== '#' && currentPath.indexOf(item.url.replace(/^\/collections\//, '')) !== -1;
      var children = item.children || [];
      if (children.length > 0) {
        var dropdownLinks = children.map(function(child) {
          return '<a href="' + child.url + '" class="evdnce-sub-nav__dropdown-item">' + child.label + '</a>';
        }).join('');
        return '<div class="evdnce-sub-nav__item--has-children' + (isActive ? ' is-active' : '') + '">' +
          '<a href="' + item.url + '" class="evdnce-sub-nav__item-label">' + item.label + CHEVRON_SVG + '</a>' +
          '<div class="evdnce-sub-nav__dropdown">' + dropdownLinks + '</div>' +
        '</div>';
      }
      return '<a href="' + item.url + '" class="evdnce-sub-nav__item' + (isActive ? ' is-active' : '') + '">' + item.label + '</a>';
    }).join('');
  }

  function initDropdownHover() {
    if (isMobile()) return;
    var subNav = document.getElementById('evdnce-sub-nav');
    if (!subNav) return;
    subNav.querySelectorAll('.evdnce-sub-nav__item--has-children').forEach(function(item) {
      var timer = null;
      function open() { clearTimeout(timer); item.classList.add('is-open'); }
      function close() { timer = setTimeout(function() { item.classList.remove('is-open'); }, 120); }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      var dropdown = item.querySelector('.evdnce-sub-nav__dropdown');
      if (dropdown) {
        dropdown.addEventListener('mouseenter', open);
        dropdown.addEventListener('mouseleave', close);
      }
    });
  }

  function buildDrawerLinks(items, gender) {
    var label = gender === 'women' ? 'Women' : gender === 'men' ? 'Men' : 'EVDNCE';
    var drawerLabel = document.getElementById('evdnce-drawer-gender-label');
    if (drawerLabel) drawerLabel.textContent = label;
    return items.map(function(item) {
      var children = item.children || [];
      if (children.length > 0) {
        var childLinks = children.map(function(child) {
          return '<a href="' + child.url + '" class="evdnce-nav-drawer__child">' + child.label + '</a>';
        }).join('');
        return '<div class="evdnce-nav-drawer__group">' +
          '<button class="evdnce-nav-drawer__parent" onclick="this.nextElementSibling.classList.toggle(\'is-open\')">' +
            item.label +
            '<svg viewBox="0 0 10 6" width="8" height="8" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" style="flex-shrink:0"><path d="M1 1l4 4 4-4"/></svg>' +
          '</button>' +
          '<div class="evdnce-nav-drawer__children">' + childLinks + '</div>' +
        '</div>';
      }
      return '<a href="' + item.url + '" class="evdnce-nav-drawer__item">' + item.label + '</a>';
    }).join('');
  }

  function openDrawer(gender) {
    var drawer = document.getElementById('evdnce-nav-drawer');
    var links  = document.getElementById('evdnce-drawer-links');
    if (!drawer || !links) return;
    links.innerHTML = buildDrawerLinks(getSubNavItems(gender), gender);
    drawer.classList.remove('evdnce-header--men', 'evdnce-header--women', 'evdnce-header--evdnce');
    drawer.classList.add('evdnce-header--' + gender);
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var btn = document.getElementById('evdnce-nav-open');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    var drawer = document.getElementById('evdnce-nav-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    var btn = document.getElementById('evdnce-nav-open');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function initDrawer() {
    var openBtn  = document.getElementById('evdnce-nav-open');
    var closeBtn = document.getElementById('evdnce-nav-close-btn');
    var overlay  = document.getElementById('evdnce-nav-close');
    if (openBtn)  openBtn.addEventListener('click',  function() { openDrawer(getGender() || 'evdnce'); });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay)  overlay.addEventListener('click',  closeDrawer);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeDrawer(); });
  }

  var mobileDropdownPanel = null;
  var mobileOpenItem = null;
  function getMobilePanel() {
    if (!mobileDropdownPanel) mobileDropdownPanel = document.getElementById('evdnce-mobile-dropdown');
    return mobileDropdownPanel;
  }
  function closeMobileDropdown() {
    var panel = getMobilePanel();
    if (panel) panel.classList.remove('is-open');
    if (mobileOpenItem) { mobileOpenItem.classList.remove('is-open'); mobileOpenItem = null; }
  }

  function applyHeaderGender(gender) {
    var header = document.getElementById('header');
    if (!header) return;
    header.classList.add('evdnce-gender-nav-active');
    header.classList.remove('evdnce-header--men', 'evdnce-header--women', 'evdnce-header--evdnce');
    header.classList.add('evdnce-header--' + gender);
    document.querySelectorAll('.evdnce-gender-tab').forEach(function (tab) {
      var isActive = tab.getAttribute('data-gender') === gender;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    var subNav = document.getElementById('evdnce-sub-nav');
    if (subNav) {
      subNav.innerHTML = buildSubNav(getSubNavItems(gender), window.location.pathname);
      subNav.scrollLeft = 0;
      setTimeout(initDropdownHover, 0);
    }
    var hamburger = document.getElementById('evdnce-nav-open');
    if (hamburger) {
      var span = hamburger.querySelector('span');
      if (span) span.textContent = 'Browse';
    }
    closeMobileDropdown();
  }

  /* Find homepage section by inner div ID, return the outer shopify-section wrapper */
  function getHomepageSection(key) {
    var inner = document.getElementById('evdnce-homepage-' + key);
    if (!inner) return null;
    /* Walk up to find the shopify-section wrapper */
    var el = inner.parentElement;
    while (el && el !== document.body) {
      if (el.id && el.id.indexOf('shopify-section') === 0) return el;
      el = el.parentElement;
    }
    return inner.parentElement;
  }

  function applyHomepageGender(gender) {
    if (!IS_HOME || IS_DESIGN_MODE) return;
    ['men', 'women', 'evdnce'].forEach(function(k) {
      var section = getHomepageSection(k);
      if (section) section.style.setProperty('display', k === gender ? 'block' : 'none', 'important');
    });
    document.body.classList.remove('evdnce-gender-loading');
  }

  function applyAll(gender) {
    applyHeaderGender(gender);
    applyHomepageGender(gender);
    if (typeof window.evdnceSetGender === 'function') window.evdnceSetGender(gender);
    if (typeof window.evdnceApplySwatchVisibility === 'function') window.evdnceApplySwatchVisibility(gender);
    if (typeof window.evdncePLPHoverRefresh === 'function') setTimeout(window.evdncePLPHoverRefresh, 100);
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.evdnce-gender-tab');
    if (!tab) return;
    e.preventDefault();
    var g = tab.getAttribute('data-gender');
    if (!g) return;
    setGender(g);
    closeDrawer();
    if (IS_HOME) { applyAll(g); } else { window.location.href = '/?gender=' + g; }
  });

  document.addEventListener('click', function (e) {
    var panel = e.target.closest('.evdnce-gender-split__panel[data-gender-tab]');
    if (!panel) return;
    var g = panel.getAttribute('data-gender-tab');
    if (!g) return;
    if (e.target.closest('.evdnce-gender-split__cta')) return;
    e.preventDefault();
    setGender(g);
    closeDrawer();
    if (IS_HOME) { applyAll(g); } else { window.location.href = '/?gender=' + g; }
  });

  document.addEventListener('click', function (e) {
    var logo = e.target.closest('.evdnce-gender-bar__logo');
    if (!logo) return;
    e.preventDefault();
    setGender('evdnce');
    closeDrawer();
    if (IS_HOME) { applyAll('evdnce'); } else { window.location.href = '/?gender=evdnce'; }
  });

  function init() {
    var urlGender    = genderFromUrl();
    var storedGender = getGender();
    var gender       = urlGender || storedGender || 'evdnce';
    setGender(gender);
    applyAll(gender);
    document.body.classList.remove('evdnce-gender-loading');
    initDrawer();
    setTimeout(initDropdownHover, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
